export const LinkBreak = () => (
  <>
    <span className="t-sr-only">LinkBreak</span>
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_602_28075)">
        <path
          d="M10.8465 10.1355L10.1385 9.429L12.2615 7.3025C12.7375 6.8265 13 6.1935 13 5.5205C13 4.8475 12.738 4.2145 12.2615 3.7385C11.785 3.2625 11.1525 3.0005 10.48 3.0005C9.8075 3.0005 9.174 3.2625 8.6975 3.739L6.571 5.862L5.865 5.1545L7.9905 3.031C8.656 2.366 9.5395 2 10.48 2C11.4205 2 12.304 2.366 12.969 3.031C13.634 3.696 14 4.58 14 5.5205C14 6.461 13.634 7.3445 12.969 8.0095L10.8465 10.1355ZM2.0215 2.7285L13.2715 13.9785L13.9785 13.2715L8.7065 7.9995L10.136 6.57L9.429 5.863L7.9995 7.2925L2.7285 2.0215L2.0215 2.7285ZM2 10.4715C2 11.4115 2.366 12.2955 3.0315 12.9605C3.6965 13.626 4.5795 13.995 5.518 14C6.453 14 7.3495 13.637 8.0095 12.9775L9.4215 11.5615L8.7135 10.8555L7.302 12.271C6.8315 12.7415 6.1675 13 5.5 13C4.8265 12.9965 4.216 12.731 3.7385 12.2535C3.2625 11.7775 3 11.1445 3 10.4715C3 9.798 3.262 9.1655 3.7385 8.6895L5.1445 7.287L4.4385 6.579L3.032 7.982C2.366 8.647 2 9.531 2 10.4715ZM7.279 9.4275L6.572 8.7205L5.864 9.4285L6.571 10.1355L7.279 9.4275Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_602_28075">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
);
